import { render, staticRenderFns } from "./UserReportListCard.vue?vue&type=template&id=03bc590e"
import script from "./UserReportListCard.vue?vue&type=script&lang=js"
export * from "./UserReportListCard.vue?vue&type=script&lang=js"
import style0 from "./UserReportListCard.vue?vue&type=style&index=0&id=03bc590e&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03bc590e')) {
      api.createRecord('03bc590e', component.options)
    } else {
      api.reload('03bc590e', component.options)
    }
    module.hot.accept("./UserReportListCard.vue?vue&type=template&id=03bc590e", function () {
      api.rerender('03bc590e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/profile/UserReportListCard.vue"
export default component.exports